/* eslint-disable max-len */
import React from 'react'

export const Duplicate = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path d="M12.96 0H0.72C0.322559 0 0 0.322559 0 0.72V12.96C0 13.3574 0.322559 13.68 0.72 13.68H12.96C13.3574 13.68 13.68 13.3574 13.68 12.96V0.72C13.68 0.322559 13.3574 0 12.96 0ZM12.24 12.24H1.44V1.44H12.24V12.24Z" fill="#inherit" />
      <path d="M16.56 14.7603V16.5603H14.76V18.0003H17.28C17.6774 18.0003 18 17.6777 18 17.2803V14.7603H16.56Z" fill="inherit" />
      <path d="M13.0967 16.5601H9.22314V18.0001H13.0967V16.5601Z" fill="inherit" />
      <path d="M5.76007 16.5603V14.7603H4.32007V17.2803C4.32007 17.6777 4.64263 18.0003 5.04007 18.0003H7.56007V16.5603H5.76007Z" fill="inherit" />
      <path d="M17.28 4.31982H14.76V5.75983H16.56V7.55983H18V5.03982C18 4.64238 17.6774 4.31982 17.28 4.31982Z" fill="inherit" />
      <path d="M18.0001 9.22314H16.5601V13.0967H18.0001V9.22314Z" fill="inherit" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="18" height="18" stroke="inherit" />
      </clipPath>
    </defs>
  </svg>
)
